import styled from 'styled-components';
import InfoModal from '@sdk/components/ui/InfoModal/InfoModal';
import ModalContainer from '@sdk/components/ui/modal/ModalContainer';

import { MIN_ROW_HEIGHT } from '@web/shiftTasks/ComposeTask/constants';

export const TaskEditModal = styled(InfoModal)`
  ${ModalContainer} {
    // react-beautiful-dnd supports only one scrollable parent
    // but if it causes any issues we might want to revisit this solution
    overflow-y: hidden;
  }
`;

TaskEditModal.defaultProps = {
  buttonsPadding: 0,
  fullScreen: true,
  zIndex: 1045,
};

export const TaskTemplateAddButton = styled.button`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border: none;
  color: ${({ theme }) => theme.colors.gray};
  display: flex;
  gap: 10px;
  height: ${MIN_ROW_HEIGHT}px;
  padding: 7px 12px;
  width: 100%;
  opacity: 0.5;
  transition: opacity ease-in-out 0.3s;
  font-size: ${({ theme }) => theme.fontSizes.l};

  &:hover {
    opacity: 1;
  }
`;
